import React from 'react'
import Plot from 'react-plotly.js'

export default function DonutChart({ title, data }) {
    // Step 1: Extract totals
    const totals = Object.values(data).map((item) => item.calculated_total)

    // Step 2: Compute grand total
    const grandTotal = totals.reduce((a, b) => a + b, 0)

    // Step 3: Convert each to percentage
    const percentages = totals.map((total) =>
        ((total / grandTotal) * 100).toFixed(2),
    )

    // Default data if none provided
    const defaultData = {
        values: [50, 50],
        labels: ['Road Services', 'Air Services'],
    }

    const generateColors = (count) => {
        const colors = [
            '#4285F4',
            '#10B981',
            '#F59E0B',
            '#EF4444',
            '#8B5CF6',
            '#06B6D4',
            '#EC4899',
            '#F97316',
            '#14B8A6',
            '#A855F7',
            '#3B82F6',
            '#22C55E',
            '#EAB308',
            '#EF4444',
            '#8B5CF6',
        ]

        // If we need more colors than defined, generate additional ones
        if (count > colors.length) {
            for (let i = colors.length; i < count; i++) {
                const hue = (i * 137.5) % 360 // Golden angle for good color distribution
                colors.push(`hsl(${hue}, 70%, 55%)`)
            }
        }

        return colors.slice(0, count)
    }

    const chartData = data
        ? {
              values: percentages.map(Number),
              labels: Object.keys(data).map((item) =>
                  item?.toLowerCase() === 'road'
                      ? 'Road Service'
                      : 'Air Service',
              ),
          }
        : defaultData
    const chartColors = generateColors(Object.keys(data)?.length)

    return (
        <div className="rounded-lg bg-white px-6 pt-6 pb-6">
            <h4 className="text-black font-bold text-lg mb-4">{title}</h4>
            <div className="flex items-center justify-center">
                <Plot
                    data={[
                        {
                            type: 'pie',
                            values: chartData.values,
                            labels: chartData.labels,
                            hole: 0.6,
                            marker: {
                                colors: chartColors,
                                line: { color: '#FFFFFF', width: 4 },
                            },
                            textinfo: 'none',
                            sort: false,
                            hovertemplate:
                                '<b>%{label}</b><br>%{percent}<extra></extra>',
                        },
                    ]}
                    layout={{
                        showlegend: true,
                        legend: {
                            orientation: 'vertical',
                            x: 0.5,
                            xanchor: 'center',
                            y: -0.15,
                            yanchor: 'top',
                            font: {
                                size: 13,
                                color: '#6B7280',
                            },
                        },
                        margin: { l: 20, r: 20, b: 80, t: 20 },
                        paper_bgcolor: 'white',
                        plot_bgcolor: 'white',
                        width: 400,
                        height: 450,
                    }}
                    config={{
                        displayModeBar: false,
                        responsive: false,
                    }}
                />
            </div>
        </div>
    )
}
